import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiResponseProperty } from '@nestjs/swagger-v4';
import { Expose } from 'class-transformer';
import { IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString, MaxLength, MinLength } from 'class-validator';
import { RoleV2BelongsToEnum, RoleV2ExposeGroup, RoleV2LevelEnum } from '../interface';
import { AllPermissionsV2 } from '../permission';
export class ReadRoleV2Dto {
}
__decorate([
    ApiResponseProperty({ type: () => String }),
    Expose({ groups: [RoleV2ExposeGroup.FIXTURE, RoleV2ExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadRoleV2Dto.prototype, "uuid", void 0);
__decorate([
    ApiResponseProperty({ type: () => String }),
    Expose({ groups: [RoleV2ExposeGroup.FIXTURE, RoleV2ExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadRoleV2Dto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ type: () => String, minLength: 3, maxLength: 255 }),
    Expose({ groups: [RoleV2ExposeGroup.FIXTURE, RoleV2ExposeGroup.READ, RoleV2ExposeGroup.CREATE, RoleV2ExposeGroup.UPDATE, RoleV2ExposeGroup.PATCH] }),
    IsString({ always: true }),
    MinLength(3, { always: true }),
    MaxLength(255, { always: true }),
    IsOptional({ groups: [RoleV2ExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadRoleV2Dto.prototype, "name", void 0);
__decorate([
    ApiProperty({ enum: RoleV2LevelEnum }),
    Expose({ groups: [RoleV2ExposeGroup.FIXTURE, RoleV2ExposeGroup.READ, RoleV2ExposeGroup.CREATE, RoleV2ExposeGroup.UPDATE, RoleV2ExposeGroup.PATCH] }),
    IsEnum(RoleV2LevelEnum, { always: true }),
    IsNotEmpty({ always: true }),
    IsOptional({ groups: [RoleV2ExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadRoleV2Dto.prototype, "level", void 0);
__decorate([
    ApiProperty({ type: () => Number }),
    Expose({ groups: [RoleV2ExposeGroup.FIXTURE, RoleV2ExposeGroup.READ, RoleV2ExposeGroup.CREATE, RoleV2ExposeGroup.UPDATE, RoleV2ExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    IsNotEmpty({ always: true }),
    IsOptional({ groups: [RoleV2ExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], ReadRoleV2Dto.prototype, "hierarchyLevel", void 0);
__decorate([
    ApiProperty({ enum: AllPermissionsV2, isArray: true }),
    Expose({ groups: [RoleV2ExposeGroup.FIXTURE, RoleV2ExposeGroup.READ, RoleV2ExposeGroup.CREATE, RoleV2ExposeGroup.UPDATE, RoleV2ExposeGroup.PATCH] }),
    IsEnum(AllPermissionsV2, { always: true, each: true }),
    IsNotEmpty({ always: true }),
    IsOptional({ groups: [RoleV2ExposeGroup.PATCH] }),
    __metadata("design:type", Array)
], ReadRoleV2Dto.prototype, "permissions", void 0);
__decorate([
    ApiResponseProperty({
        enum: RoleV2BelongsToEnum,
    }),
    Expose({ groups: [RoleV2ExposeGroup.FIXTURE, RoleV2ExposeGroup.READ] }),
    __metadata("design:type", String)
], ReadRoleV2Dto.prototype, "belongsTo", void 0);
//# sourceMappingURL=ReadRoleV2Dto.js.map